import React from 'react';
import { Typography, type SxProps, type Theme } from '@mui/material';

export interface MissingRequirementsHintProps {
  missingSeller?: boolean;
  missingDate?: boolean;
  sx?: SxProps<Theme>;
}

/** Explains why a confirm button is disabled while seller/date are still unchosen. */
const MissingRequirementsHint: React.FC<MissingRequirementsHintProps> = ({
  missingSeller = false,
  missingDate = false,
  sx,
}) => {
  if (!missingSeller && !missingDate) {
    return null;
  }
  const text =
    missingSeller && missingDate
      ? 'Seleccione el vendedor y la fecha para continuar.'
      : missingSeller
        ? 'Seleccione un vendedor para continuar.'
        : 'Seleccione la fecha y hora para continuar.';

  return (
    <Typography
      variant="caption"
      color="text.secondary"
      role="status"
      sx={[{ display: 'block', lineHeight: 1.4 }, ...(Array.isArray(sx) ? sx : [sx])]}
    >
      {text}
    </Typography>
  );
};

export default MissingRequirementsHint;
